import { useMemo, useState } from "react";
import { Button } from "~/components/Button";
import { GoalForm, type GoalKey } from "~/components/form/resources/GoalForm";
import { ListingGroup } from "~/components/layout/ListingGroup";
import { ListingItem } from "~/components/layout/ListingItem";
import { Page } from "~/components/layout/Page";
import { SectionHeader } from "~/components/layout/SectionHeader";
import { Authorize } from "~/components/permission/Authorize";
import { Can } from "~/components/permission/Can";
import { useProfile } from "~/providers/ProfileProvider";

export default function GoalsIndex() {
    const { profile } = useProfile();
    const [adding, setAdding] = useState(false);
    const goals = useMemo(
        () => Object.entries(profile?.goals ?? {}).filter(([, value]) => Boolean(value)) as [GoalKey, string][],
        [profile],
    );

    const has_goals = goals.length >= 1;
    const can_add = goals.length <= 2;
    const next_goal = useMemo<GoalKey | null>(
        () => ((Object.entries(profile?.goals ?? {}).find(([, value]) => !value) as [GoalKey, string]) ?? [null])[0],
        [profile],
    );

    return (
        <Authorize ability="view" section="goals">
            <Page spacer>
                <SectionHeader
                    title="My goals"
                    icon="heart"
                    button={() => (
                        <Can ability="update" section="goals">
                            <Button
                                title="Add goal"
                                variant="primary"
                                size="lg"
                                onPress={() => setAdding(true)}
                                disabled={!can_add}
                            />
                        </Can>
                    )}
                >
                    Add your top 3 goals
                </SectionHeader>
                {has_goals && (
                    <ListingGroup>
                        {goals.map(([id, goal]) => (
                            <ListingItem
                                href={{ pathname: "/resources/goals/[id]", params: { id } }}
                                key={id}
                                title={goal}
                                hideChevron
                            />
                        ))}
                    </ListingGroup>
                )}
            </Page>
            <Can ability="update" section="goals">
                {adding && next_goal ? <GoalForm id={next_goal} onRequestClose={() => setAdding(false)} /> : null}
            </Can>
        </Authorize>
    );
}
